import Template from '../../component/Template.js';
import { useEffect, useRef } from 'react';
import Api from '../../component/Api';
import { useState } from 'react';
import React from "react";
import { useNavigate } from 'react-router-dom';
import useAuth from '../../component/useAuth.js';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { toast } from 'react-toastify';
import '../../Assets/css/resptable.css'
import '../../Assets/css/responsiveptable.css'
import 'datatables.net';
import 'datatables.net-bs4/css/dataTables.bootstrap4.min.css';
import Select from 'react-select';
import { Input } from '@mui/material';
import { Badge } from "@mui/material";
import { wait } from '@testing-library/user-event/dist/utils/index.js';
import { set } from 'date-fns';

export default function ExamVerification() {

  const navigate = useNavigate();
  const isAuth = useAuth();

  if (isAuth === false) {
    navigate("/college/");
  }

  const tableRef = useRef(null);

  const [disciplineId, setDisciplineChange] = useState(sessionStorage.getItem("discipline_id") ? sessionStorage.getItem("discipline_id") : null);
  const [disciplinetype, setDisciplineTypeChange] = useState(sessionStorage.getItem("discipline_type") ? sessionStorage.getItem("discipline_type") : null);
  const [examid, setExamIdData] = useState(sessionStorage.getItem("eaxm_id") ? sessionStorage.getItem("eaxm_id") : null);


  const [url, setUrl] = useState(null);
  const [registrationcount, setRegistrationcount] = useState({});
  //const [disciplinetype, setDisciplineTypeChange] = useState(null);
  const [disciplineName, setDisciplineNameChange] = useState(null);
  const [flag, setflag] = useState(false);
  const [disciplinedata, setDisciplineData] = useState([]);
  const [isSelectAllChecked, setIsSelectAllChecked] = useState(false);
  const [loading, setlodaing] = useState(false);
  const [selectedRows, setSelectedRows] = useState([]); // Object to track selected rows
  const [totalAmount, setTotalAmount] = useState(0); // Track the total amount
  const [totalDemand, setTotalDemand] = useState(0);
  const [status, setStatus] = useState(false);
  const [activeDate, setActiveDate] = useState(false);
  const [getexamData, setExamData] = useState([]);
  const [courseListData, setCourseListData] = useState([]);
  const [examlink, setExamlink] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [showStatusModal, setShowStatusModal] = useState(false);
  const [statusmsg, setStatusmsg] = useState(null);
  const [appar, setAappar] = useState(false);
  const [reload, setreload] = useState(0);
  const [showFeeModal, setShowFeeModal] = useState(false);
  const { http } = Api();
  const [courseFeeDetails, setCourseFeeDetails] = useState({

    fees: [],
    fineDetails: [],
    concessions: []
  });
  const paperTypeLabel = {
    I: 'Internship',
    P: 'Practical',
    T: 'Theory',
    R: 'Regular'
  };
  const formatDate = (date) => {
    if (!date) return "";
    const d = new Date(date);
    const day = String(d.getDate()).padStart(2, "0");
    const month = String(d.getMonth() + 1).padStart(2, "0");
    const year = d.getFullYear();
    return `${day}/${month}/${year}`;
  };

  let cid = localStorage.getItem("collegeid");

  const isAnyCheckboxSelected = Object.values(selectedRows).some(isSelected => isSelected);


  useEffect(() => {

    http.get(`getActiveEvents`, { params: { event_id: 5 } })
      .then(response => {


        if (response.data[0].status === "active") {

          setStatus(response.data[0].status);
          setActiveDate(response.data[0].end_date);
        }
        else {
          setStatus(false);
        }


      }).catch(error => {
        // console.error("Error in get active events:", error);

      });


  }, [])


  const handlExamChange = (selectedOption) => {

    setExamIdData(selectedOption.value);
    setDisciplineChange(false);
    setDisciplineNameChange(false);
    setDisciplineTypeChange(false);
    setCourseListData([]);


  };

  useEffect(() => {
    const fetchExamData = async () => {
      try {
        const response = await http.get(`College/getActiveExams`);
        // console.log("response", response.data);
        setExamData(response.data);
      }
      catch (error) {

        if (error.response.data.http_status === 401 && error.response.data.status_code == "ERR9") {
          toast.error("Invalid Token");
          setTimeout(() => {
            navigate("/college/");
          }, 5000);

        }
        else if (error.response.data.http_status === 429 && error.response.data.status_code == "ERR33") {
          toast.error(error.response.data.message);
        }
        else if (error.response.data.http_status === 500 && error.response.data.status_code == "ERR5") {
          toast.error("No active exam found");
        }
        else {
          toast.error("Something went wrong");
        }
      }
    };

    fetchExamData();
  }, []);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await http.get(`/College/getSchemeWiseCollegeDisciplines`, {
          params: {
            examid: examid,
            college_id: cid
          }
        });
        if (response.data.status_code === 'ERR5') {
          setflag(true);
        }
        setDisciplineData(response.data);

      }
      catch (error) {
        if (error.response.data.http_status === 401 && error.response.data.status_code == "ERR9") {
          toast.error("Invalid Token");
          setTimeout(() => {
            navigate("/college/");
          }, 5000);

        }
        else if (error.response.data.http_status === 429 && error.response.data.status_code == "ERR33") {
          toast.error(error.response.data.message);
        }
        else {
          toast.error("Something went wrong");
        }
      }
    };

    fetchData();
  }, [examid]);


  const handleDisciplineChange = (selectedOption) => {
    setDisciplineChange(selectedOption.did);
    setDisciplineNameChange(selectedOption.value);
    setDisciplineTypeChange(selectedOption.type);
  };


  useEffect(() => {

    const fetchListData = async () => {
      try {
        const response = await http.get(`/College/viewStudentCourseApprovalList`, {
          params: {
            examid: examid,
            discipline_id: disciplineId,
            college_course_type: disciplinetype
          }
        });
        // console.log(response.data.studentlist);
        setCourseListData(response.data.studentlist);
        setlodaing(false);

      }
      catch (error) {
        setlodaing(false);
        if (error.response.data.http_status === 401 && error.response.data.status_code == "ERR9") {
          toast.error("Invalid Token");
          setTimeout(() => {
            navigate("/college/");
          }, 5000);

        }
        else if (error.response.data.http_status === 429 && error.response.data.status_code == "ERR33") {
          toast.error(error.response.data.message);
        }
        else if (error.response.data.http_status === 500 && error.response.data.status_code == "ERR5") {
          toast.error(error.response.data.message);
        }
        else {
          toast.error("Something went wrong");
        }
      }
    };

    const Registrationcount = async () => {
      try {
        const response = await http.get(`College/getCollegeDisciplineRegistrationcount`, {
          params: {
            examid: examid,
            discipline_id: disciplineId,
            college_course_type: disciplinetype
          }
        });

        setRegistrationcount(response.data[0]);

      }
      catch (error) {
        if (error.response.data.http_status === 401 && error.response.data.status_code == "ERR9") {
          toast.error("Invalid Token");
          setTimeout(() => {
            navigate("/college/");
          }, 5000);
          setlodaing(false);
        }
      }
    }


    if (examid && disciplineId) {


      setSelectedRows([]);
      setIsSelectAllChecked(false);
      setlodaing(true);

      fetchListData();
      Registrationcount();

    }
  }, [examid, disciplineId, disciplinetype, reload])

  useEffect(() => {
    const principalViewStudentCourseFees = async () => {
      http.get('College/principalViewStudentCourseFees', {
        params: {
          examid: examid
        }
      }).then(response => {
        setCourseFeeDetails(response.data);
      }).catch(error => {
        const err = error.response?.data;

        if (err?.http_status === 401 && err?.status_code === "ERR9") {
          toast.error("Invalid Token");
          setTimeout(() => {
            navigate("/college/");
          }, 5000);
        }
        else if (err?.http_status === 429 && err?.status_code === "ERR33") {
          toast.error(err.message);
        }
        else if (err?.http_status === 500 && err?.status_code === "ERR5") {
          toast.error(err.message);
        }
        else {
          toast.error("Something went wrong");
        }
      });
    };
    if (examid) {
      principalViewStudentCourseFees();
    }
  }, [examid, reload])

  console.log("courseFeeDetails", courseFeeDetails)
  const handleSelectAll = () => {
    const allSelected = !isSelectAllChecked;
    setIsSelectAllChecked(allSelected);

    if (allSelected) {

      const allStudentIds = Object.entries(courseListData)
        .filter(([_, studentDetails]) => studentDetails?.exam_reg_status === 'Approved By DEO' && studentDetails?.malpractice_status === 0)
        .map(([apaarId]) => apaarId);

      setSelectedRows(allStudentIds);
      setShowFeeModal(false);

    } else {

      setSelectedRows([]);
    }
  };

  const handleRowSelect = (apaarId) => {

    if (selectedRows.includes(apaarId)) {

      const newselected = selectedRows.filter(id => id !== apaarId)
      setSelectedRows(newselected);

      if (newselected.length === 0) {
        setIsSelectAllChecked(false);
      }

    } else {

      setSelectedRows([...selectedRows, apaarId]);
    }
  };


  useEffect(() => {

    const newTotal = selectedRows.reduce((sum, apaarId) => {
      return sum + parseFloat(courseListData[apaarId].fees);
    }, 0);

    const DemandTotal = selectedRows.reduce((sum, apaarId) => {
      return sum + parseFloat(courseListData[apaarId].Demand_fees);
    }, 0);

    setTotalAmount(newTotal);
    setTotalDemand(DemandTotal);

  }, [selectedRows, courseListData]);


  const handlePayment = (e) => {

    setlodaing(true);

    e.preventDefault();

    http.post(`College/PaymentByPrincipal`, {


      examid: examid,
      apaar_no: selectedRows,
      amount: totalAmount,
      is_demand: 'false'

    }).then(response => {



      setExamlink(response.data.reqParam);
      setUrl(response.data.url)



    }).catch(error => {
      if (error.response?.data?.status_code === 'ERR9') {
        console.log("Invalid Token");
      }
    })

  }

  const handleDemand = (e) => {

    setlodaing(true);

    e.preventDefault();

    http.post(`College/PaymentByPrincipal`, {


      examid: examid,
      apaar_no: selectedRows,
      amount: totalDemand,
      is_demand: 'true'

    }).then(response => {



      setExamlink(response.data.reqParam);
      setUrl(response.data.url)



    }).catch(error => {
      if (error.response?.data?.status_code === 'ERR9') {
        console.log("Invalid Token");
      }
    })

  }

  useEffect(() => {

    if (examlink && url) {
      // Create a form element
      const form = document.createElement('form');
      form.method = 'POST';
      form.action = url;
      form.id = 'frmpaymentaction';

      // Create input element
      const input = document.createElement('input');
      input.type = 'hidden';
      input.name = 'epay_req_params';
      input.value = examlink;
      input.id = 'epay_req_params';

      // Append input to form
      form.appendChild(input);

      // Append form to document body
      document.body.appendChild(form);

      // Submit the form
      form.submit();

      // Clean up - remove form after submission
      return () => {
        if (document.getElementById('frmpaymentaction')) {
          document.body.removeChild(form);
        }
        setlodaing(false);

      };
    }
  }, [examlink, url]);


  const student_del = () => {
    setShowModal(false);

    http.post(`College/deleteStudentExamRegistrationRecords`, {

      examid: examid,
      apaar_no: appar

    }).then(response => {
      // console.log(response);
      if (response.data.message.status_code === "MSG3") {

        toast.success("DEO Registration Reverted successfully");
        setreload(1);
        setAappar(false);
      }

    }).catch(error => {
      if (error.response.data.status_code === 'ERR9') {
        console.log("Invalid Token")
        setAappar(false);

      }
    });
  }

  const confirmEdit = (apparid) => {
    setShowModal(true);
    setAappar(apparid);
  };

  const handleClose1 = () => {
    setShowModal(false);
    setAappar(false);
  }

  const handleViewModal = (apaar_id) => {
    const statusmsg = courseListData[apaar_id] ? courseListData[apaar_id] : null;
    setStatusmsg(statusmsg.deo_remarks);
    setShowStatusModal(true);

  };

  const closeModal = () => {
    setShowStatusModal(false);
  };

  //custom  discipline style
  const disciplineStyles = {

    option: (provided, state) => {
      const label = state.data.label || "";
      const suffix = label.split("-")[1]?.trim();  // SF / AIDED

      let color = "black";
      if (suffix === "SF") color = "#252393";
      if (suffix === "AIDED") color = "green";

      if (state.isSelected) {
        return {
          ...provided,
          backgroundColor: "#ebebeb",
          color: color,   // KEEP suffix color even when selected
          fontWeight: "600",
        };
      }

      return {
        ...provided,
        color: color,
      };
    },

    // THIS makes the selected item in the select box colored
    singleValue: (provided, state) => {
      const label = state.data.label || "";
      const suffix = label.split("-")[1]?.trim();

      let color = "black";
      if (suffix === "SF") color = "#252393";
      if (suffix === "AIDED") color = "green";

      return {
        ...provided,
        color: color,
        fontWeight: "600",
      };
    },
    menu: (provided) => ({
      ...provided,
      maxHeight: '200px',
      overflowY: 'auto',
    }),
    menuList: (provided) => ({
      ...provided,
      maxHeight: '200px',
      overflowY: 'auto',
      scrollbarWidth: 'thin',
      scrollbarColor: '#888 #f1f1f1',
    }),
    multiValue: (provided) => ({
      ...provided,
      '&::-webkit-scrollbar': {
        width: '8px',
      },
      '&::-webkit-scrollbar-track': {
        background: '#f1f1f1',
      },
      '&::-webkit-scrollbar-thumb': {
        background: '#888',
        borderRadius: '4px',
      },
      '&::-webkit-scrollbar-thumb:hover': {
        background: '#555',
      },
    }),
  };

  return (
    <>
      <ToastContainer />
      <Template>

        {loading ? (


          <div className="container-fluid">
            <div className="row justify-content-center align-items-center">
              <div className="col-sm-12">
                <div className="card h-100">
                  <div className="card-body d-flex justify-content-center align-items-center" style={{ minHeight: '400px' }}>
                    <div className="containeranimate">
                      <div className="dot"></div>
                      <div className="dot"></div>
                      <div className="dot"></div>
                      <div className="dot"></div>
                      <div className="dot"></div>
                      <div className="dot"></div>
                      <div className="dot"></div>
                      <div className="dot"></div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

        ) : (


          <div className="my-page">

            <div className="container-fluid">

              <div className={`modal fade show ${showModal ? 'd-block' : ''}`} id="exampleModalCenter1" tabIndex="-1" role="dialog" aria-labelledby="exampleModalCenter1" aria-model="true" style={{ backdropFilter: 'blur(2px)' }}>
                <div className="modal-dialog modal-dialog-centered" role="document">
                  <div className="modal-content">
                    <div className="modal-body">
                      <div className="modal-toggle-wrapper">
                        <h4 className="text-center pb-2">Are you sure you want to Revert?</h4>
                        <div className="d-flex justify-content-center mt-3">
                          <button className="btn btn-danger mx-2" onClick={student_del}>Revert</button>
                          <button className="btn " style={{ backgroundColor: 'white', borderColor: 'red', color: 'black' }} data-bs-dismiss="modal" onClick={() => handleClose1()}>Cancel</button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="row">
                <div className="col-sm-12">
                  <div className="card">
                    <div className="col-md-12">
                      <div className="card-header">
                        <div className="py-3 d-flex justify-content-between align-items-center ">
                          <h5>Student Exam Registration Approval</h5>
                          <div className="buttons-container">




                          </div>
                        </div>

                      </div>
                      <div className="card-body">



                        <div className="card-body pdg">
                          <div className="table-responsive">

                            <div className="form theme-form">
                              <div className="card-body custom-input">


                                <div className="row">
                                  <div className="col-md-6">
                                    <label>Exam<span className="errorclr">*</span></label>

                                    <Select
                                      maxMenuHeight={200}
                                      menuPlacement="auto"
                                      id="exam_id"
                                      name="exam_id"
                                      className="basic-select"
                                      classNamePrefix="select"
                                      options={getexamData.map(exam => ({
                                        value: exam.examid,
                                        label: exam.examtitle
                                      }))}
                                      onChange={handlExamChange}
                                      placeholder="Select an exam..."

                                      value={getexamData
                                        .filter(exam => exam.examid.toString() == examid ? examid.toString() : '')
                                        .map(exam => ({
                                          value: exam.examid,
                                          label: exam.examtitle
                                        }))[0]}
                                    />
                                  </div>


                                  <div className="col-md-6">
                                    <label>Discipline<span className="errorclr">*</span></label>
                                    <Select
                                      maxMenuHeight={200}
                                      menuPlacement="auto"
                                      id="discipline_id"
                                      name="discipline_id"
                                      className="form"
                                      styles={disciplineStyles}
                                      onChange={handleDisciplineChange}
                                      options={Array.isArray(disciplinedata) && disciplinedata.length > 0
                                        ? disciplinedata
                                          .sort((a, b) => a.discipline_name.localeCompare(b.discipline_name))
                                          .map(discipline => ({
                                            did: discipline.discipline_id,
                                            value: discipline.discipline_name,
                                            label: discipline.discipline_name,
                                            type: discipline.college_course_type
                                          }))
                                        : [{ value: '0', label: 'No data found' }]
                                      }
                                      value={disciplinedata && Array.isArray(disciplinedata)
                                        ? disciplinedata
                                          .filter(discipline =>
                                            discipline.discipline_id == disciplineId &&
                                            discipline.college_course_type == disciplinetype
                                          )
                                          .map(discipline => ({

                                            did: discipline.discipline_id,
                                            value: discipline.discipline_name,
                                            label: discipline.discipline_name,
                                            type: discipline.college_course_type

                                          }))
                                        : null}
                                    />

                                  </div>


                                </div>


                                {status != 'active' && (
                                  <div className="txt-aln">
                                    <p style={{ color: 'red', marginBottom: '10px' }}>Exam registration approval time is closed.No actions can be performed.</p>

                                  </div>
                                )}


                                <div class="table-container">
                                  <table className="table-striped table-bordered ex-table" ref={tableRef} id="dataTable">
                                    <thead>
                                      <tr className="col-cnt-tab-bg-clr">
                                        <th scope="col" width="10%">Sl No.</th>
                                        <th scope="col" width="">Total Students</th>
                                        <th scope="col" width="">Registered Students</th>
                                        <th scope="col" width="">Approved by DEO</th>
                                        <th scope="col" width="">Payment done by Principal</th>
                                      </tr>
                                    </thead>

                                    <tbody>
                                      <tr>
                                        <td data-label="Sl No.">{registrationcount.totalStudents ? 1 : "--"}</td>
                                        <td data-label="Total Students">{registrationcount.totalStudents ? registrationcount.totalStudents : "0"}</td>
                                        <td data-label="Registered Students">{registrationcount.RegCnt ? registrationcount.RegCnt : "0"}</td>
                                        <td data-label="Approved by DEO">{registrationcount.AprCnt ? registrationcount.AprCnt : "0"}</td>
                                        <td data-label="Payment done by Principal">{registrationcount.AprPrincipal ? registrationcount.AprPrincipal : "0"}</td>

                                      </tr>
                                    </tbody>
                                  </table>
                                </div>
                                <div class="table-container">
                                  <div className="row m-t-20 align-items-center">

                                    {/* LEFT: Select All */}
                                    {status === "active" && Object.keys(courseListData).length > 0 && (
                                      <div className="col-md-4">
                                        <div className="m-t-10">
                                          <input
                                            id="select-all"
                                            type="checkbox"
                                            onChange={handleSelectAll}
                                            checked={isSelectAllChecked}
                                          />
                                          <label htmlFor="select-all">&nbsp;Select All</label>
                                        </div>
                                      </div>
                                    )}

                                    {/* RIGHT AREA (PAYMENT + ICON TOGETHER) */}
                                    <div className="col-md-8">
                                      <div className={`d-flex  align-items-center w-100 
                                      ${isAnyCheckboxSelected && status === "active"
                                          ? "justify-content-end" : "justify-content-between"}
                                        `}
                                      >

                                        {/* LEFT SIDE INSIDE RIGHT COLUMN = CONDITIONAL PAYMENT BLOCK */}
                                        <div>
                                          {isAnyCheckboxSelected && status === "active" && (
                                            <div className="d-flex align-items-center gap-3 p-r-5">

                                              {/* Payment Summary Card */}
                                              <div className="card border-0 shadow-sm">
                                                <div className="card-body p-3">
                                                  <div className="d-flex align-items-center gap-4">
                                                    <div>
                                                      <small className="text-muted d-block mb-1">Total Demand</small>
                                                      <h5 className="mb-0 text-dark">
                                                        ₹{totalDemand.toLocaleString()}
                                                      </h5>
                                                    </div>

                                                    <div className="vr"></div>

                                                    <div>
                                                      <small className="text-muted d-block mb-1">
                                                        Payable Amount
                                                      </small>
                                                      <h5 className="mb-0 text-success">
                                                        ₹{totalAmount.toLocaleString()}
                                                      </h5>
                                                    </div>
                                                  </div>
                                                </div>
                                              </div>

                                              {/* Payment Buttons */}
                                              <div className="d-flex flex-column gap-2">
                                                {/* <form onSubmit={handleDemand}>
                                                  <button
                                                    className="btn btn-outline-primary w-100"
                                                    type="submit"
                                                  >
                                                    <i className="bi bi-cash-stack me-2"></i>
                                                    Pay Demand (₹{totalDemand.toLocaleString()})
                                                  </button>
                                                </form> */}
                                                <button
                                                  type="button"
                                                  className="btn btn-outline-primary w-100 btn-zoom ms-auto d-flex align-items-center justify-content-center gap-2"

                                                  onClick={() => setShowFeeModal(true)}
                                                  title="View fee details"
                                                >
                                                  <i className="bi bi-info-circle-fill"></i>
                                                  Fee Info
                                                </button>

                                                <form onSubmit={handlePayment}>
                                                  <button
                                                    className="btn btn-primary btn-zoom w-100"
                                                    type="submit"
                                                  >
                                                    <i className="bi bi-credit-card me-2"></i>
                                                    Pay Amount (₹{totalAmount.toLocaleString()})
                                                  </button>
                                                </form>
                                              </div>
                                            </div>
                                          )}
                                        </div>

                                        {/* ===== INFO ICON (ALWAYS EXTREME RIGHT) ===== */}

                                        {/* {courseFeeDetails?.fees?.length > 0 && ( */}
                                        {!isAnyCheckboxSelected && courseFeeDetails?.fees?.length > 0 && (
                                          <>
                                            <button
                                              type="button"
                                              className="fee-info-btn btn-zoom ms-auto d-flex align-items-center justify-content-center gap-2 m-r-5"

                                              onClick={() => setShowFeeModal(true)}
                                              title="View fee details"
                                            >
                                              <i className="bi bi-info-circle-fill"></i>
                                              Fee Info
                                            </button>
                                          </>
                                        )}

                                      </div>
                                    </div>
                                  </div>








                                  {showFeeModal && (
                                    <div className="college-fee-part">
                                      <div className="fee-overlay" onClick={() => setShowFeeModal(false)}>

                                        <div className="fee-modal" onClick={(e) => e.stopPropagation()}>

                                          {/* ===== HEADER ===== */}
                                          <div className="fee-modal-header">
                                            <h4>Fee Overview</h4>
                                            <button
                                              className="fee-close-btn"
                                              onClick={() => setShowFeeModal(false)}
                                            >
                                              ×
                                            </button>
                                          </div>

                                          {/* ===== BODY ===== */}
                                          <div className="fee-modal-body">

                                            {/* -------- FEE DETAILS TABLE -------- */}
                                            <div className="fee-card">
                                              <h6 className="card-title"><i className="fa fa-file-invoice me-2"></i> Fee Details</h6>

                                              <table className="modern-table">
                                                <thead>
                                                  <tr>
                                                    <th width="10%" data-label="Sl No">Sl. No.</th>
                                                    <th width="60%" data-label="Description">Description</th>
                                                    <th width="30%" data-label="₹">Amount (₹)</th>
                                                  </tr>
                                                </thead>
                                                <tbody>
                                                  {courseFeeDetails.fees?.map((item, index) => (
                                                    <tr key={index}>
                                                      <td data-label="Sl No:">{index + 1}</td>
                                                      <td data-label="Description:">{item.feedesc} - (
                                                        <span style={{ color: "#581f37", fontWeight: "600" }}>
                                                          {paperTypeLabel[item.papertype] || item.papertype}
                                                        </span>
                                                        )</td>
                                                      <td data-label="₹:">₹ {item.feeamt}</td>
                                                    </tr>
                                                  ))}
                                                </tbody>
                                              </table>
                                            </div>

                                            {/* -------- FINE DETAILS TABLE -------- */}
                                            <div className="fee-card mt-4">
                                              <h6 className="card-title"> <i className="fa fa-exclamation-triangle me-2"></i> Fine Details</h6>

                                              <table className="modern-table">
                                                <thead>
                                                  <tr>
                                                    <th colSpan="2">Fine</th>
                                                    <th colSpan="2">Super Fine</th>
                                                  </tr>
                                                  <tr>
                                                    <th>Start Date</th>
                                                    <th>Amount</th>
                                                    <th>Start Date</th>
                                                    <th>Amount</th>
                                                  </tr>
                                                </thead>
                                                <tbody>
                                                  {courseFeeDetails.fineDetails?.length > 0 && (
                                                    <tr>
                                                      <td data-label="Fine start date">{formatDate(courseFeeDetails.fineDetails[0].feefinestdt)}</td>
                                                      <td data-label="₹">₹ {courseFeeDetails.fineDetails[0].feefineamt}</td>
                                                      <td data-label="Super fine date">{formatDate(courseFeeDetails.fineDetails[0].feesupfinestdt)}</td>
                                                      <td data-label="₹">₹ {courseFeeDetails.fineDetails[0].feesupfineamt}</td>
                                                    </tr>
                                                  )}
                                                </tbody>
                                              </table>
                                            </div>

                                            {/* -------- CONCESSION TABLE -------- */}
                                            <div className="fee-card mt-4">
                                              <h6 className="card-title"><i className="fa fa-ticket me-2"></i> Concession Fee Details</h6>

                                              <table className="modern-table">
                                                <thead>
                                                  <tr>
                                                    <th>Concession Type</th>
                                                    <th>Concession Amount</th>
                                                  </tr>
                                                </thead>
                                                <tbody>
                                                  {courseFeeDetails.concessions?.map((item, index) => (
                                                    <tr key={index}>
                                                      <td><b>{item.concession_type}</b></td>
                                                      <td>₹ {item.amount_payable}</td>
                                                    </tr>
                                                  ))}
                                                </tbody>
                                              </table>
                                            </div>

                                          </div>

                                          {/* ===== FOOTER ===== */}
                                          <div className="fee-modal-footer">
                                            <button
                                              className="btn-cancel"
                                              onClick={() => setShowFeeModal(false)}
                                            >
                                              Close
                                            </button>
                                          </div>

                                        </div>
                                      </div>
                                    </div>
                                  )}








                                  <table className=" dataTable   ex-v-table " ref={tableRef} id="dataTable">
                                    <thead>
                                      <tr className="bg-primary">
                                        <th scope="col" width="4%">

                                          {status === "active" && Object.keys(courseListData).length > 0 && (

                                            <input id="select-all" type="checkbox"
                                              onChange={handleSelectAll}
                                              checked={isSelectAllChecked} />
                                          )}

                                        </th>
                                        <th scope="col" width="5%">Sl No</th>
                                        <th scope="col" width="9%">APAAR / PRN</th>
                                        <th scope="col" width="9%">Name</th>
                                        <th scope="col" width="30%">Courses</th>
                                        <th scope="col" width="7%">Demand</th>
                                        <th scope="col" width="7%">Amount</th>
                                        <th scope="col" width="7%">Action</th>
                                      </tr>
                                    </thead>
                                    <tbody>
                                      {Object.keys(courseListData).length > 0 ? (
                                        Object.keys(courseListData).map((apaar_id, index) => {
                                          const student = courseListData[apaar_id];

                                          return (
                                            <tr key={apaar_id} style={student.exam_reg_status === "Not Registered" ? { backgroundColor: '#FEF6F7' } : {}}>
                                              <td scope="row" className="text-center">
                                                {student.exam_reg_status === 'Approved By DEO' && status === "active" && student.malpractice_status === 0 && ( student.courses.some(course => course.condonation_status === 'Condonation Paid') || student.courses.every(course => course.condonation_status === 'Not Applicable') ) && (
                                                  <input
                                                    type="checkbox"
                                                    checked={selectedRows.includes(apaar_id)}
                                                    onChange={() => handleRowSelect(apaar_id)}
                                                  />
                                                )}
                                              </td>
                                              <td className="text-center">
                                                {index + 1}
                                              </td>
                                              <td data-label="APAAR Id" style={{ fontSize: '12px', fontWeight: 'bold' }}>
                                                {student.exam_reg_status === 'Approved By Principal' ? (
                                                  <div className="txt-aln m-b-10">
                                                    <span class="badge badge-success text-white rounded-pill">
                                                      <i class="bi bi-check2-all" aria-hidden="true" style={{ cursor: "pointer", fontSize: "1.5em" }} ></i>
                                                    </span>.
                                                  </div>
                                                ) : student.exam_reg_status === 'Approved By DEO' ? (
                                                  <div className="txt-aln m-b-10">
                                                    <span class="badge badge-success text-white rounded-pill">
                                                      <i class="fa fa-clipboard-check" aria-hidden="true" style={{ cursor: "pointer", fontSize: "1.5em" }} ></i>
                                                    </span>
                                                  </div>
                                                ) : student.exam_reg_status === 'Entry Level' && (
                                                  <div className="txt-aln m-b-10">
                                                    <span class="badge badge-warning text-white rounded-pill">
                                                      <i className="fa  fa-clipboard" style={{ cursor: "pointer", fontSize: "1.5em" }}></i>
                                                    </span>
                                                  </div>
                                                )}
                                                <div className='txt-aln'>{apaar_id} / {student.PRN}</div>
                                              </td>

                                              <td data-label="Name" className="text-center" style={{ fontSize: '12px', fontWeight: 'bold' }} >{student.studentname}</td>

                                              <td>
                                                <div className="treeview">
                                                  <ul>
                                                    {student.courses.map((course, index) => (

                                                      <li key={index} className="ex-v-tab-li-fnt"><b>{course.paper_identifier}</b> - {course.course_name} - <b style={{ color: "blue" }}>{course.coursetype}</b>
                                                        <span class={`badge rounded-pill ${course.paper_status === "registered" ? "bg-success" : "bg-danger"}`} style={{ marginLeft: '1em' }}>{course.paper_status}</span>
                                                      </li>

                                                    ))}

                                                  </ul>
                                                </div>
                                              </td>
                                              <td className="text-center" data-label="Demand_fees">₹ {student.Demand_fees}</td>
                                              <td className="text-center" data-label="fees">₹ {student.fees}</td>
                                              <td className="text-center" data-label="Action" >
                                                {(() => {
                                                  if (student.malpractice_status === 1) {

                                                    return <span className='badge rounded-pill bg-danger'>Malpractice</span>;
                                                  }
                                                  else {


                                                    switch (student.exam_reg_status) {
                                                      case 'Approved By DEO':
                                                        if (status === "active") {
                                                          return (
                                                            <>
                                                              <i className="icon-comment-alt" style={{ cursor: "pointer", fontSize: "1.5em" }} aria-hidden="true" aria-label="View Remark" onClick={() => handleViewModal(apaar_id)}></i>&nbsp;&nbsp;

                                                              <i className="fa fa-undo" style={{ cursor: "pointer", fontSize: "1.5em", color: "red" }} aria-hidden="true" aria-label="Revert DEO Registration" onClick={() => confirmEdit(apaar_id)}></i>
                                                            </>
                                                          );
                                                        } else {
                                                          return <div className="txt-aln">Deo Approved</div>;
                                                        }
                                                      case 'Not Registered':
                                                        return <div className="txt-aln">DEO Verification Pending</div>;
                                                      case 'Approved By Principal':
                                                        return <span>Fee Paid - Forwarded to University</span>;
                                                      default:
                                                        return <span> DEO Forwarding Pending</span>;
                                                    }
                                                  }
                                                })()}
                                              </td>

                                            </tr>
                                          );

                                        })
                                      ) : (
                                        <tr>
                                          <td colSpan="6" className="text-center">No data found</td>
                                        </tr>
                                      )}
                                    </tbody>
                                  </table>


                                  {showStatusModal && (
                                    <div className="modal fade show d-block" style={{ backdropFilter: 'blur(2px)' }}>
                                      <div className="modal-dialog modal-dialog-centered">
                                        <div className="modal-content">
                                          <div className="modal-header">
                                            <h5 className="modal-title">Remarks</h5>
                                            <div className="close" onClick={closeModal} style={{ cursor: "pointer", fontSize: "1.5em" }}>&times;</div>
                                          </div>
                                          <div className="modal-body">
                                            {statusmsg ? (
                                              <p>{statusmsg}</p>) : (
                                              <p>no remarks</p>
                                            )}
                                          </div>

                                        </div>
                                      </div>
                                    </div>
                                  )}


                                </div>

                              </div>


                            </div>



                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}


      </Template>
    </>
  );
}
